// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivateMobileLayout_wrapper__ecq2X","content":"PrivateMobileLayout_content__38Xfo"};